export default "https://cdn-static.gokick.com/assets/42f530e1bfe0c3dccbac116cd4d83f20c9a8b744/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";